// extracted by mini-css-extract-plugin
module.exports = {"details":"WorkTypeDetails_details__1IdAj"};